import React from 'react'

import { AttentionOutlined, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

// Always rendered so its height is reserved; the inputs above never shift when
// the error toggles on an invalid code.
function ErrorMessage({ hasError }) {
  return (
    <div className="auth-modal__code-error" role="alert">
      {hasError && (
        <>
          <Icon color="warning" notSpaced size="small" svgComponent={AttentionOutlined} />
          <span className="cgt-caption-semibold auth-modal__code-error-text">
            Invalid access code. Please try again.
          </span>
        </>
      )}
    </div>
  )
}

ErrorMessage.propTypes = {
  hasError: bool.isRequired,
}

export default ErrorMessage
